import axios from "axios";

export const getFunctions = () => axios.get("/api/bms/function").then(res => res.data);
export const saveFunction = data => axios.post("/api/bms/function/save", data).then(res => res.data);
export const updateFunctionStatus = (id, status) => axios.post(`/api/bms/function/${id}/status/${status}`).then(res => res.data);
export const deleteFunction = id => axios.post(`/api/bms/function/${id}/delete`).then(res => res.data);

export const FUNCTION_OPTIONS = [
  { value: "ACCIDENT", label: "出险", productNames: ["出险"] },
  { value: "MAINTENANCE", label: "维保", productNames: ["维保"] },
  { value: "BATTERY", label: "电池健康", productNames: ["车云检", "电池健康", "电池报告"] },
  { value: "VEHICLE_MODEL", label: "车型识别", productNames: ["车型识别"] },
  { value: "OBD", label: "云端调表", productNames: ["云端查表", "云端调表"] },
  { value: "MILEAGE_CHAIN", label: "里程链", productNames: ["里程链"] },
];
